import { Sparkles, ArrowRight, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

/**
 * Sticky banner shown across the top of /admin-demo to remind prospects this
 * is a sales preview & nudge them to a real Care Plan.
 */
export default function DemoBanner() {
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    if (sessionStorage.getItem('demo_banner_dismissed')) setHidden(true);
  }, []);

  if (hidden) return null;

  return (
    <div
      data-testid="demo-banner"
      className="sticky top-0 z-[60] bg-gradient-to-r from-[#00E5FF] via-[#00B4D8] to-violet-500 text-[#0A0A0A] border-b border-white/10 shadow-lg shadow-cyan-500/10"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-2 flex items-center gap-3">
        <span className="inline-flex items-center gap-1.5 bg-[#0A0A0A]/90 text-[#00E5FF] px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest backdrop-blur">
          <Sparkles className="w-3 h-3" />
          Live demo
        </span>
        <p className="text-xs sm:text-sm font-semibold flex-1 truncate">
          You're viewing sample data. Every site we build comes with this admin panel.
        </p>
        <Link
          to="/pricing"
          data-testid="demo-banner-cta"
          className="hidden sm:inline-flex items-center gap-1.5 bg-[#0A0A0A] text-white px-3.5 py-1.5 rounded-full text-xs font-bold hover:bg-[#1a1a1a] transition-colors flex-shrink-0"
        >
          Get yours from £60/mo
          <ArrowRight className="w-3 h-3" />
        </Link>
        <Link
          to="/pricing"
          data-testid="demo-banner-cta-mobile"
          className="sm:hidden inline-flex items-center gap-1 bg-[#0A0A0A] text-white px-3 py-1.5 rounded-full text-[11px] font-bold flex-shrink-0"
        >
          Get yours
          <ArrowRight className="w-3 h-3" />
        </Link>
        <button
          type="button"
          aria-label="Hide demo banner"
          data-testid="demo-banner-dismiss"
          onClick={() => { sessionStorage.setItem('demo_banner_dismissed', '1'); setHidden(true); }}
          className="w-7 h-7 rounded-full hover:bg-black/15 flex items-center justify-center transition-colors flex-shrink-0"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
